import { BlockContent } from "../types/schema";

// represents the union of all types that could be in BlockContent
type BlockType = BlockContent[number];

export function reduceRichText(
  richText?: BlockContent,
  delimiter?: string,
): string {
  if (!richText) {
    return "";
  }
  return richText.reduce((prev: string, cur: BlockType) => {
    switch (cur._type) {
      case "block":
        const children = cur.children ?? [];
        const blockText = children.map(
          (c: { text?: string }) => c["text"] ?? "",
        );
        return [prev, ...blockText].join(delimiter ?? " ");
      case "video":
      case "image":
      case "customImage":
      case "break":
      default:
        return prev;
    }
  }, "");
}
